<template>
 <div >
      <div v-if="!loggedIn"> 
           <!-- if not logged in then show login button  -->
          <login> </login>
      </div>
       <div v-else > 
           <!-- if you are logged in then show the dashboard  -->
          <dashboard> </dashboard> 
       </div>
 </div>
</template>

<script>
   import Login from '@/Pages/Auth/Login'
    import Dashboard from '@/Pages/Dashboard'  
 
    export default { 
        components:{
            Login,
            Dashboard,
            // NrnaLayout
        },

        props: {
            canLogin: Boolean,
            canRegister: Boolean,
             loggedIn: Boolean 
        }
    }
</script>
